import { render, staticRenderFns } from "./DesignOutcome.vue?vue&type=template&id=2aa66ddf&scoped=true&lang=pug&"
import script from "./DesignOutcome.vue?vue&type=script&lang=js&"
export * from "./DesignOutcome.vue?vue&type=script&lang=js&"
import style0 from "./DesignOutcome.vue?vue&type=style&index=0&id=2aa66ddf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa66ddf",
  null
  
)

export default component.exports